import { render, staticRenderFns } from "./Impression.vue?vue&type=template&id=354e2644&scoped=true&"
import script from "./Impression.vue?vue&type=script&lang=js&"
export * from "./Impression.vue?vue&type=script&lang=js&"
import style0 from "./Impression.vue?vue&type=style&index=0&id=354e2644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e2644",
  null
  
)

export default component.exports